import { isAdmin } from '../role/isAdmin';
import { isVisibleNoAccess } from '../role/isVisibleNoAccess';
import { TargetUserOnAccessChangeView } from './types/view';

type HasProcessAndSiteAccessResult =
  | {
      result: true;
      processAccess: boolean;
      siteAccess: boolean;
      reasons: null;
    }
  | {
      result: false;
      processAccess: boolean;
      siteAccess: boolean;
      reasons: string[];
    };

export function hasProcessAndSiteAccess({
  targetUser,
  siteId,
  processId,
}: {
  targetUser: TargetUserOnAccessChangeView;
  siteId: string;
  processId: string;
}): HasProcessAndSiteAccessResult {
  if (isAdmin(targetUser.role)) {
    return {
      result: true,
      processAccess: true,
      siteAccess: true,
      reasons: null,
    };
  }
  if (isVisibleNoAccess(targetUser.role)) {
    return {
      result: false,
      processAccess: false,
      siteAccess: false,
      reasons: ['tooltip_access_cannot_change_for_visible_no_access' as const],
    };
  }

  const processAccess = targetUser.processes.includes(processId);
  const siteAccess = targetUser.sites.includes(siteId);
  if (processAccess && siteAccess) {
    return {
      result: true,
      processAccess: true,
      siteAccess: true,
      reasons: null,
    };
  }
  const reasons: string[] = [];

  if (!processAccess) {
    reasons.push('tooltip_access_cannot_change_because_of_process' as const);
  }

  if (!siteAccess) {
    reasons.push('tooltip_access_cannot_change_because_of_site' as const);
  }

  return {
    result: false,
    processAccess,
    siteAccess,
    reasons,
  };
}
